import{transparentize as zr}from"polished";var p=(e,o)=>zr(1-e,o);var t={transparent:"transparent",black:"rgb(0, 0, 0)",white:"rgb(255, 255, 255)",blue:{50:"rgb(225, 246, 254)",75:"rgb(217, 233, 243)",100:"rgb(180, 230, 254)",150:"rgb(135, 191, 224)",200:"rgb(131, 214, 253)",300:"rgb(79, 199, 251)",400:"rgb(40, 186, 251)",500:"rgb(0, 174, 249)",600:"rgb(0, 159, 234)",700:"rgb(0, 140, 214)",800:"rgb(0, 123, 194)",850:"rgb(0, 113, 178)",900:"rgb(1, 102, 160)",950:"rgb(1, 57, 102)",1e3:"rgb(0, 36, 64)"},grey:{50:"rgb(250, 250, 250)",100:"rgb(245, 245, 245)",200:"rgb(238, 238, 238)",300:"rgb(224, 224, 224)",400:"rgb(189, 189, 189)",500:"rgb(158, 158, 158)",600:"rgb(117, 117, 117)",700:"rgb(97, 97, 97)",800:"rgb(66, 66, 66)",900:"rgb(38, 38, 38)",1e3:"rgb(20, 20, 20)"},red:{50:"rgb(247, 209, 209)",100:"rgb(244, 186, 186)",200:"rgb(240, 163, 163)",300:"rgb(232, 117, 117)",350:"rgb(228, 94, 94)",400:"rgb(225, 71, 71)",500:"rgb(217, 25, 25)",600:"rgb(195, 23, 23)",700:"rgb(174, 20, 20)",800:"rgb(152, 18, 18)",900:"rgb(130, 15, 15)",1e3:"rgb(109, 13, 13)",1100:"rgb(87, 10, 10)"},purple:{500:"rgb(197, 138, 249)",800:"rgb(104, 29, 168)"}};function Jt(e,o){return Array.isArray(e)&&e.length===2?e[o]:Object.entries(e).reduce((r,[a,i])=>(r[a]=Jt(i,o),r),{})}function Yt(e,o){return Object.entries(e).reduce((r,[a,i])=>(r[a]=Jt(i,o),r),{})}var fe=[t.blue[800],t.blue[400]],Lr=[t.grey[50],t.grey[1e3]],qr=[t.blue[50],t.blue[1e3]],Re=[t.grey[900],t.white],Wr=[t.grey[700],t.grey[300]],Ur=[t.grey[500],t.grey[500]],D=[t.grey[300],t.grey[800]],Xt=[t.grey[500],t.grey[500]],Kt=[t.grey[700],t.grey[200]],pt=[p(.1,t.blue[800]),p(.1,t.blue[400])],ct=[p(.2,t.blue[800]),p(.2,t.blue[400])],mt=[p(.05,t.black),p(.1,t.white)],ut=[p(.1,t.black),p(.2,t.white)],Or=[t.blue[900],t.blue[300]],gt=[t.grey[200],t.grey[800]],Nr=[t.red[500],t.red[350]],_r=[p(.75,t.black),p(.5,t.white)],jt={accent:fe,background:Lr,backdrop:_r,emptyStateCard:qr,stroke:{light:[t.grey[300],t.grey[800]],mid:[t.grey[500],t.grey[600]],dark:[t.grey[700],t.grey[400]],dark2:[t.grey[800],t.grey[300]]},mainText:Re,secondaryText:Wr,notes:Ur,disabledContent:D,iconDefault:Xt,action:Kt,blueHover:pt,bluePress:ct,greyHover:mt,greyPress:ut,focus:Or,group:gt,alert:Nr,buttons:{primary:{default:[t.blue[800],t.blue[800]],hover:[t.blue[850],t.blue[700]],pressed:[t.blue[900],t.blue[600]],disabled:[t.blue[75],t.blue[1e3]],content:[t.white,t.white],disabledContent:[t.blue[150],t.blue[900]]},secondary:{default:[t.transparent,t.transparent],hover:pt,pressed:ct,disabled:[t.transparent,t.transparent],content:fe,disabledContent:D},teritary:{default:[t.grey[200],t.grey[800]],hover:[t.grey[300],t.grey[700]],pressed:[t.grey[400],t.grey[600]],disabled:[t.grey[100],t.grey[900]],content:[t.grey[800],t.grey[200]],disabledContent:D},embedded:{default:[t.transparent,t.transparent],hover:mt,hoverOnDark:[p(.1,t.white),p(.1,t.white)],pressed:ut,pressedOnDark:[p(.2,t.white),p(.2,t.white)],disabled:[t.transparent,t.transparent],content:[t.grey[700],t.white],contentOnDark:[t.grey[200],t.grey[200]],disabledContent:D},secondaryOutlined:{default:[t.grey[200],t.grey[800]],hover:[t.grey[300],t.grey[700]],pressed:[t.grey[400],t.grey[600]],content:[t.grey[800],t.grey[200]]},link:{default:fe,hover:[t.blue[900],t.blue[300]],pressed:[t.blue[950],t.blue[200]],used:[t.purple[800],t.purple[500]],disabled:D},buttonTile:{default:[t.grey[200],t.grey[800]],hover:[t.grey[300],t.grey[700]],pressed:[t.grey[400],t.grey[600]],disabled:[t.grey[100],t.grey[900]],text:fe,disabledText:[t.grey[300],t.grey[700]]},cardButton:{default:[t.white,t.grey[900]],hover:pt,pressed:ct,text:fe},primaryDestructive:{defaultBackgroud:[t.red[500],t.red[500]],defaultContent:[t.white,t.white],hoverBackground:[t.red[600],t.red[400]],hoverContent:[t.white,t.white],pressedBackground:[t.red[700],t.red[350]],pressedContent:[t.white,t.white],disabledBackground:[t.red[50],t.red[1e3]],disabledContent:[t.red[100],t.red[900]],inProgressBackground:[t.red[50],t.red[1e3]],inProgressContent:[t.red[100],t.red[900]]},secondaryDestructive:{defaultBackgroud:[t.transparent,t.transparent],defaultContent:[t.red[500],t.red[500]],hoverBackground:[p(.1,t.red[500]),p(.1,t.red[500])],hoverContent:[t.red[500],t.red[500]],pressedBackground:[p(.2,t.red[500]),p(.2,t.red[500])],pressedContent:[t.red[500],t.red[500]],disabledBackground:[t.transparent,t.transparent],disabledContent:D,inProgressBackground:[t.transparent,t.transparent],inProgressContent:D},flatDestructive:{defaultBackgroud:[t.transparent,t.transparent],defaultContent:[t.red[500],t.red[500]],hoverBackground:[p(.1,t.red[500]),p(.1,t.red[500])],hoverContent:[t.red[500],t.red[500]],pressedBackground:[p(.2,t.red[500]),p(.2,t.red[500])],pressedContent:[t.red[500],t.red[500]],disabledBackground:[t.transparent,t.transparent],disabledContent:D,inProgressBackground:[t.transparent,t.transparent],inProgressContent:D}},tooltips:{fill:gt,content:Re,shadow:[p(.25,t.black),p(.25,t.black)]},hint:{fill:[t.blue[800],t.blue[950]],content:[t.white,t.white],shadow:[p(.25,t.black),p(.25,t.black)]},checkbox:{defaultText:Re,defaultFill:[t.blue[800],t.blue[600]],hover:[t.blue[600],t.blue[700]],pressed:[t.blue[400],t.blue[800]],disabled:[t.grey[300],t.grey[800]]},radioButton:{defaultText:Re,defaultFill:[t.blue[800],t.blue[600]],hover:[t.blue[600],t.blue[700]],pressed:[t.blue[400],t.blue[800]],disabled:[t.grey[300],t.grey[800]]},toggle:{shadow:[p(.3,t.black),p(.3,t.black)],on:{defaultHandle:[t.blue[800],t.blue[600]],defaultTrack:[t.blue[600],t.blue[800]],hoverHandle:[t.blue[600],t.blue[400]],hoverTrack:[t.blue[400],t.blue[600]],disabledHandle:[t.blue[50],t.blue[950]],disabledTrack:[t.blue[50],t.blue[950]]},off:{defaultHandle:[t.grey[300],t.grey[400]],defaultTrack:[t.grey[500],t.grey[600]],hoverHandle:[t.grey[200],t.grey[300]],hoverTrack:[t.grey[400],t.grey[500]],disabledHandle:[t.grey[100],t.grey[800]],disabledTrack:[t.grey[200],t.grey[800]]}},dataUsageBar:{used:[t.blue[600],t.blue[700]],total:gt},menu:{fill:[t.white,t.grey[900]],shadow:[p(.25,t.black),p(.25,t.black)],itemFill:[t.transparent,t.transparent],itemContent:Kt,itemIcon:Xt,itemHoverFill:mt,itemPressedFill:ut,itemDisabledContent:D},thumbnail:{contentOnDark:[t.white,t.white],collectionOutline:[t.blue[500],t.blue[500]]}},Zr=Yt(jt,0),_s=Yt(jt,1);import*as O from"@radix-ui/react-accordion";import De from"styled-components";import{forwardRef as rn}from"react";import{mergeProps as nn,useButton as an,useFocusRing as ln,useHover as sn}from"react-aria";import dn,{css as Ae}from"styled-components";import{ProgressBar as Qr}from"react-aria-components";import{jsx as Ie,jsxs as Xr}from"react/jsx-runtime";function eo(e){return Ie(Qr,{...e,children:Xr("svg",{width:"24",height:"24",viewBox:"0 0 24 24",style:{display:"block"},children:[Ie("path",{fill:"currentColor",d:"M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",opacity:".25"}),Ie("path",{fill:"currentColor",d:"M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",children:Ie("animateTransform",{attributeName:"transform",type:"rotate",dur:"0.75s",values:"0 12 12;360 12 12",repeatCount:"indefinite"})})]})})}var n={25:"0.25rem",50:"0.5rem",75:"0.75rem",100:"1rem",125:"1.25rem",150:"1.5rem",200:"2rem",250:"2.5rem",300:"3rem",350:"3.5rem",400:"4rem"},d={small:"0.25rem",medium:"0.5rem",mediumLarge:"0.75rem",large:"1rem",round:"99px"},s={innerGap:n[50],componentInlinePadding:n[75],horizontalComponentGap:n[100]},w={xSmall:n[150],small:n[200],medium:n[250],large:n[300],xLarge:n[350]};import K,{css as q}from"styled-components";var he=q`
    line-height: normal;
    font-size: 1rem; // 16px
`,h=q`
    line-height: normal;
    font-size: 1rem; // 16px
`,be=q`
    line-height: normal;
    font-size: 0.75rem; // 12px
`,W=q`
    line-height: normal;
    font-size: 0.875rem; // 14px
`,to=q`
    line-height: normal;
    font-size: 1.25rem; // 20px
`,ft=q`
    color: ${({theme:e})=>e.mainText};
`,ht=q`
    margin: 0;
`,bt=q`
    /* reset */
    ${ht}

    /* content */
    ${ft}
    ${he}
`,Kr=K.h2`
    /* reset */
    ${ht}
    font-weight: 700;

    /* content */
    ${ft}
    font-size: 1.375rem; // 22px
`,Jr=K.h3`
    /* reset */
    ${ht}

    /* content */
    ${ft}
    font-weight: 700;
    font-size: 1.125rem; // 18px
`,Yr=K.p`
    ${bt}
`,jr=K.strong`
    font-weight: 700;
`,en=K.span`
    color: ${({theme:e})=>e.notes};
    font-size: 0.75rem; // 12px
`,tn=K.a`
    /* reset */
    cursor: pointer;

    /* content */
    color: ${({theme:e})=>e.buttons.link.default};
    text-decoration: underline;
    text-underline-offset: ${n[25]};

    &:hover {
        color: ${({theme:e})=>e.buttons.link.hover};
    }

    &:active {
        color: ${({theme:e})=>e.buttons.link.pressed};
    }

    &:visited {
        color: ${({theme:e})=>e.buttons.link.used};
    }
`,on=K.hr`
    border: none;
    border-top: 1px solid ${({theme:e})=>e.stroke.light};
`,c={Divider:on,SectionHeader:Kr,Subheader:Jr,Paragraph:Yr,Bold:jr,Link:tn,Secondary:en};import{jsx as oo,jsxs as pn}from"react/jsx-runtime";var y=Ae`
  all: unset;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
`,Y=Ae`
    min-width: 104px;
    width: fit-content;
    padding-inline: ${s.componentInlinePadding};
    display: flex;
    align-items: center;
    gap: ${s.innerGap};
    justify-content: center;
`,xe=Ae`
    border-radius: ${d.small};
    border-width: 1px;
    border-style: solid;
`,U=Ae`
    /* layout */
    padding-inline: 0;
    justify-content: center;

    width: ${({$variant:e})=>J(e)};
    min-width: ${({$variant:e})=>J(e)};
`,ro=rn(function(o,r){let{onPress:a,icon:i,isDisabled:l,isPending:g,propagateWhenDisabled:u,...x}=o,R=u||!l?a:void 0,{buttonProps:te,isPressed:oe}=an({onPress:R},r),{focusProps:it,isFocused:lt,isFocusVisible:st}=ln(o),{hoverProps:ke,isHovered:F}=sn(o),ge=nn(x,te,it,ke),{onHoverChange:_t,onHoverStart:Zt,onHoverEnd:Qt,...dt}=ge,Vr=(function(){return g?oo(eo,{"aria-label":"Pending\u2026"}):i?oo(i,{color:"currentColor"}):null})();return pn("button",{...dt,type:o.type,disabled:l,"data-disabled":l||void 0,"data-pending":g||void 0,"data-pressed":oe||void 0,"data-hovered":F||void 0,"data-focused":lt||void 0,"data-focus-visible":st||void 0,ref:r,children:[Vr,o.children]})});ro.displayName="ReactAriaButton";function J(e){switch(e){case"large":return w.large;case"medium":return w.medium;case"small":return w.small}}var v=dn(ro)`
    /* reset */
    ${y}

    /* layout */
    ${Y}

    /* content */
    ${h}

    /* appearance */
    ${xe}

    &[data-disabled], &[data-pending] {
        cursor: not-allowed;
    }
    &[data-focus-visible] {
        outline: ${({theme:e})=>e.focus} solid 1px;
    }

    height: ${({$variant:e})=>J(e)};
    width: ${({$fluid:e})=>e?"100%":"fit-content"};
`;import{jsx as no}from"react/jsx-runtime";var cn=e=>no("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:no("path",{fill:e.color??"currentColor",d:"M12 15.97q-.2 0-.375-.063a.9.9 0 0 1-.325-.212l-4.6-4.6a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.424 0 .7.275l3.9 3.9 3.9-3.9a.95.95 0 0 1 .7-.275q.424 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063"})}),ao=cn;import{jsx as ye,jsxs as io}from"react/jsx-runtime";var mn=De(O.Trigger)`
    /* reset */
    ${y}

    /* layout */
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${n[25]};
    padding-inline: ${s.componentInlinePadding};

    /* appearance */
    border-radius: ${d.small};

    .expand-icon {
        transition: transform 0.3s;
    }

    &[data-state='open'] {
        .expand-icon {
            transform: rotate(180deg);
        }
    }

    &:hover {
        background-color: ${({theme:e})=>e.greyHover};
    }

    &:active {
        background-color: ${({theme:e})=>e.greyPress};
    }
`,un=De(c.Divider)`
    margin-inline: ${s.componentInlinePadding};
    margin-block: ${n[25]} ${n[50]};
`,gn=De(O.Root)`
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
`,fn=({children:e,...o})=>io(mn,{...o,children:[ye(c.SectionHeader,{children:e}),ye(ao,{className:"expand-icon","aria-hidden":!0})]}),hn=De(O.Content)`
    /* reset content */
    ${bt}

    /* layout */
    padding-inline: ${s.componentInlinePadding};
    display: flex;
    flex-direction: column;
    gap: 1rem;
`,bn=({title:e,children:o,...r})=>io(O.AccordionItem,{value:e,...r,children:[ye(fn,{children:e}),ye(un,{}),ye(hn,{children:o})]});import V from"styled-components";var lo='data:image/svg+xml,<svg width="282" height="282" viewBox="0 0 282 282" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M252.377 75.6069H29.6228V221.45H252.377V75.6069Z" fill="%2300ABFA"/>%0A<path d="M149.164 220.61C149.164 225.119 145.509 228.774 141 228.774C136.491 228.774 132.836 225.119 132.836 220.61" fill="%2300ABFA"/>%0A<path d="M143.92 215.787C143.92 215.787 199.637 192.698 246.296 215.787H143.92Z" fill="%23016EC4"/>%0A<path d="M143.001 79.3761C143.001 79.3761 198.266 66.1972 246.092 79.3761L246.304 216.478C246.304 216.478 206.13 194.159 144.061 215.416L142.999 79.3761H143.001Z" fill="%23D9F5FF"/>%0A<path d="M38.3994 210.56C38.3994 210.56 94.5919 201.004 138.141 215.873L38.3413 216.191L38.3994 210.56Z" fill="%23016EC4"/>%0A<path d="M139.542 216.017C139.542 216.017 87.194 199.374 36.0801 213.52V76.2102C36.0801 76.2102 75.2384 54.1573 139.542 79.955V216.017Z" fill="%23D9F5FF"/>%0A<path d="M236.133 105.824H184.666V157.292H236.133V105.824Z" fill="white"/>%0A<path d="M231.604 110.352H189.193V152.762H231.604V110.352Z" fill="%23D9F5FF"/>%0A<path d="M220.991 115.747H169.523V167.215H220.991V115.747Z" fill="white"/>%0A<path d="M216.463 120.275H174.053V162.685H216.463V120.275Z" fill="%23B2C1FF"/>%0A<path d="M202.829 125.696H151.361V177.164H202.829V125.696Z" fill="white"/>%0A<path d="M198.3 130.224H155.889V172.634H198.3V130.224Z" fill="%23016EC4"/>%0A<path d="M198.3 159.127H155.889V172.634H198.3V159.127Z" fill="%2341BAFA"/>%0A<path d="M169.523 159.128C169.523 154.946 172.912 151.557 177.093 151.557C181.275 151.557 184.663 154.946 184.663 159.128" fill="%23D9F5FF"/>%0A<path d="M102.379 93.7502H52.5935V143.536H102.379V93.7502Z" fill="white"/>%0A<path d="M97.9995 98.1301H56.9753V139.154H97.9995V98.1301Z" fill="%23016EC4"/>%0A</svg>%0A';var so='data:image/svg+xml,<svg width="332" height="332" viewBox="0 0 332 332" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_4102_4121)">%0A<path d="M331.31 0H0V331.31H331.31V0Z" fill="%23EEEEEE"/>%0A<path d="M0 272.29L110.05 165.66L173.49 245.68L259.84 107.82L331.31 211.78V331.31H0V272.29Z" fill="%23E0E0E0" fill-opacity="0.5"/>%0A<path d="M66 118.39C84.4905 118.39 99.48 103.4 99.48 84.91C99.48 66.4195 84.4905 51.43 66 51.43C47.5095 51.43 32.52 66.4195 32.52 84.91C32.52 103.4 47.5095 118.39 66 118.39Z" fill="%23F5F5F5"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_4102_4121">%0A<rect width="331.31" height="331.31" fill="white"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';import{forwardRef as Sn}from"react";import Pn from"styled-components";import vn from"styled-components";var N=vn(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.embedded.default};
    color: ${({theme:e})=>e.buttons.embedded.content};
    border-color: ${({theme:e})=>e.buttons.embedded.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.embedded.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.embedded.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.embedded.default};
        color: ${({theme:e})=>e.buttons.embedded.disabledContent};
    }
`;import{jsx as po}from"react/jsx-runtime";var $n=Pn(N).attrs({$variant:"small"})`
    ${U}
    /* content */
    color: ${({$color:e,theme:o})=>e??o.action};
`,P=Sn(({icon:e,color:o,...r},a)=>po($n,{$color:o,...r,ref:a,children:po(e,{color:"currentcolor"})}));P.displayName="EmbeddedIconButton";import{jsx as co}from"react/jsx-runtime";var wn=e=>co("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:co("path",{fill:e.color??"currentColor",d:"M6 14q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 12q0-.825.588-1.412A1.93 1.93 0 0 1 6 10q.824 0 1.412.588Q8 11.175 8 12t-.588 1.412A1.93 1.93 0 0 1 6 14m6 0q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 12q0-.825.588-1.412A1.93 1.93 0 0 1 12 10q.825 0 1.412.588Q14 11.175 14 12t-.588 1.412A1.93 1.93 0 0 1 12 14m6 0q-.824 0-1.413-.588A1.93 1.93 0 0 1 16 12q0-.825.587-1.412A1.93 1.93 0 0 1 18 10q.824 0 1.413.588Q20 11.175 20 12t-.587 1.412A1.93 1.93 0 0 1 18 14"})}),mo=wn;import{Content as Tn,Item as Bn,Portal as Cn,Root as kn,Trigger as Rn}from"@radix-ui/react-dropdown-menu";import{forwardRef as ho}from"react";import bo from"styled-components";import{css as fo}from"styled-components";var re="0px 2px 4px 0px",uo="-2px 0px 4px 0px",go="0px 2px 3px 0px";var Me=fo`
    /* reset */
    outline: none;
    user-select: none;

    /* layout */
    min-width: 168px; // magic number from design
    padding-block: ${n[25]};
    margin-top: ${n[25]};
    margin-inline: ${n[25]};

    /* content */
    ${h}

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    border: 1px solid ${({theme:e})=>e.stroke.light};
    border-radius: ${d.small};
    box-shadow: ${({theme:e})=>`${re} ${e.menu.shadow}`};
`,ne=fo`
    /* reset */
    outline: none;
    cursor: pointer;
    box-sizing: border-box;

    /* layout */
    padding-inline: ${s.componentInlinePadding};
    height: ${w.large};
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${s.innerGap};

    /* content */
    color: ${({$selected:e,theme:o})=>e?o.accent:o.menu.itemContent};

    /* appearance */
    background-color: ${({theme:e})=>e.menu.itemFill};

    &:focus-visible,
    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.menu.itemHoverFill};
    }

    &:active:not([data-disabled]) {
        background-color: ${({theme:e})=>e.menu.itemPressedFill};
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.menu.itemDisabledContent};
        cursor: not-allowed;
    }
`;import{jsx as xt,jsxs as Dn}from"react/jsx-runtime";var In=bo(Tn)`
    ${Me}
`,An=bo(Bn)`
    ${ne}
`,xo=ho(({children:e,icon:o,...r},a)=>Dn(An,{...r,ref:a,children:[o&&xt(o,{color:"currentColor"}),e]}));xo.displayName="DropdownMenuItem";var yo=ho(({children:e,...o},r)=>xt(Cn,{children:xt(In,{...o,ref:r,children:e})}));yo.displayName="DropdownMenuContent";var I={Root:kn,Trigger:Rn,Content:yo,Item:xo};import{jsx as j,jsxs as Ee}from"react/jsx-runtime";var Mn=V.figure`
    /* reset */
    margin: 0;
`,En=V.div`
    /* reset */
    user-select: none;
    position: relative;

    /* content */
    color: ${({theme:e})=>e.thumbnail.contentOnDark};

    /* layout */
    min-width: 160px;
    min-height: 160px;
    aspect-ratio: 1;

    /* appearance */
    border-radius: ${d.medium};
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.5) 0%,
            rgba(0, 0, 0, 0.1) 25%,
            rgba(0, 0, 0, 0) 37.5%,
            rgba(0, 0, 0, 0) 62.5%,
            rgba(0, 0, 0, 0.1) 75%,
            rgba(0, 0, 0, 0.5) 100%
        );
    }
`,vo=V.img`
    /* appearance */
    width: 100%;
    height: 100%;
    object-fit: cover;
`,Hn=V(c.Subheader)`
    font-size: 1rem;
`,Gn=V.figcaption`
    /* layout */
    margin-top: ${n[25]};
    margin-left: ${n[25]};
`,Fn=V.div.attrs({"aria-hidden":!0,role:"presentation"})`
    /* layout */
    position: absolute;
    bottom: ${n[50]};
    left: ${n[50]};
`,Vn=V.div.attrs({"aria-hidden":!0,role:"presentation"})`
    /* layout */
    position: absolute;
    bottom: ${n[50]};
    right: ${n[50]};
`,zn=V.div.attrs({"aria-hidden":!0,role:"presentation"})`
    /* layout */
    position: absolute;
    top: ${n[50]};
    right: ${n[50]};
`,ve=({title:e,subtitle:o,coverPhoto:r,children:a})=>Ee(Mn,{children:[Ee(En,{children:[r?j(vo,{src:r,alt:e,onError:i=>{i.currentTarget.src=so}}):j(vo,{src:lo,alt:e}),a]}),Ee(Gn,{children:[j(Hn,{children:e}),j(c.Paragraph,{children:o})]})]}),Ln=V(P)`
    /* content */
    color: ${({theme:e})=>e.thumbnail.contentOnDark};
`,qn=({children:e,...o})=>Ee(I.Root,{children:[j(I.Trigger,{asChild:!0,children:j(Ln,{...o,"aria-label":"Menu",icon:mo})}),j(I.Content,{align:"end",children:e})]});ve.BottomLeft=Fn;ve.BottomRight=Vn;ve.TopRight=zn;ve.MenuButton=qn;import{forwardRef as Un}from"react";import{jsx as So}from"react/jsx-runtime";var Wn=e=>So("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:So("path",{fill:e.color??"currentColor",d:"M6.4 19H8q.424 0 .713.288Q9 19.575 9 20q0 .424-.287.712A.97.97 0 0 1 8 21H4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20v-4q0-.424.288-.713A.97.97 0 0 1 4 15q.424 0 .713.287Q5 15.576 5 16v1.6l2.4-2.4a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7zM19 6.4l-2.4 2.4a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7L17.6 5H16a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 4q0-.424.287-.712A.97.97 0 0 1 16 3h4q.424 0 .712.288Q21 3.575 21 4v4q0 .424-.288.713A.97.97 0 0 1 20 9a.97.97 0 0 1-.712-.287A.97.97 0 0 1 19 8z"})}),Po=Wn;import{jsx as On}from"react/jsx-runtime";var $o=Un(({...e},o)=>On(P,{icon:Po,color:"white",...e,ref:o}));$o.displayName="ThumbnailExpandPreviewButton";import He from"styled-components";import{jsx as wo,jsxs as Xn}from"react/jsx-runtime";var To=He.figure`
    cursor: pointer;

    /* reset */
    user-select: none;
    position: relative;

    /* content */
    color: ${({theme:e})=>e.thumbnail.contentOnDark};

    /* layout */
    width: 102px;
    height: 142px;
    aspect-ratio: 1;

    margin: ${n[25]};

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-radius: ${d.medium};
        background: linear-gradient(
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.27) 100%
        );
    }
`,Nn=He(To)`
    margin: 0px;

    padding: 1px;
    border-radius: ${d.mediumLarge};
    border: 3px solid ${({theme:e})=>e.thumbnail.collectionOutline};

    &::before {
        left: 1px;
        top: 1px;
        right: 1px;
        bottom: 1px;
    }
`,_n=He.figcaption`
    /* layout */
    position: absolute;
    bottom: ${n[50]};
    left: 50%;
    transform: translate(-50%, 0);
    width: 95%; /* Limit caption width to be 12 characters per line */

    font-weight: 700;
    text-align: center;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
`,Zn=He.img`
    /* appearance */
    width: 100%;
    height: 100%;
    border-radius: ${d.medium};

    object-fit: cover;
`,Qn=({coverPhoto:e,title:o,hasSeen:r})=>Xn(r?To:Nn,{children:[wo(Zn,{as:"object",type:"image/jpg","aria-label":o,data:e}),wo(_n,{children:o})]});import*as Ge from"@radix-ui/react-toggle";import*as Fe from"@radix-ui/react-toggle-group";import Se,{css as ko}from"styled-components";import{jsx as Bo}from"react/jsx-runtime";var Kn=e=>Bo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Bo("path",{fill:e.color??"currentColor",d:"m12 13.4-4.9 4.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7l4.9-4.9-4.9-4.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l4.9 4.9 4.9-4.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L13.4 12l4.9 4.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275z"})}),_=Kn;import{jsx as ae,jsxs as Co}from"react/jsx-runtime";var Ro=ko`
    /* reset */
    ${y}

    /* layout */
    ${Y}
    margin: 0;
    height: ${w.medium};
    gap: ${n[50]};

    /* content */
    color: ${({theme:e})=>e.action};

    /* appearance */
    ${xe}
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.round};

    svg {
        margin: -${n[25]};
        fill: ${({theme:e})=>e.iconDefault};
    }

    &:focus-visible {
        outline: ${({theme:e})=>e.focus} solid 2px;
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.disabledContent};
        cursor: not-allowed;

        svg {
            fill: ${({theme:e})=>e.disabledContent};
        }
    }
`,Jn=Se(Fe.Root)`
    /* layout */
    display: flex;
    align-items: center;
    gap: ${s.innerGap};
`,yt=Se(Ge.Root)`
    ${Ro}

    /* layout */
    padding-inline: ${n[100]};

    /* appearance */
    border-color: ${({theme:e})=>e.stroke.light};

    &:hover:not([data-disabled]) {
        background-color: ${({theme:e})=>e.greyHover};
    }

    &:active:not([data-disabled]) {
        background-color: ${({theme:e})=>e.emptyStateCard};
    }

    svg.context-icon {
        fill: ${({theme:e,$defaultIconColor:o})=>o??e.iconDefault};
    }

    &[data-disabled] {
        color: ${({theme:e})=>e.disabledContent};
        cursor: not-allowed;

        svg {
            fill: ${({theme:e})=>e.disabledContent};
        }
    }
`,vt=ko`
    ${Ro}

    /* layout */
    padding-inline: 0;
    width: fit-content;

    /* content */
    color: ${({theme:e})=>e.accent};

    /* appearance */
    background-color: ${({theme:e})=>e.emptyStateCard};
    border-color: ${({theme:e})=>e.accent};

    svg.context-icon {
        fill: ${({theme:e})=>e.accent};
    }
`,Yn=Se.section`
    ${vt}

    /* reset */
    cursor: default;

    /* layout */
    gap: ${n[50]};
    padding-left: ${n[100]};

    svg {
        margin: -${n[25]};
        fill: ${({theme:e})=>e.iconDefault};
    }
`,St=Se(Ge.Root)`
    /* reset */
    ${y}

    /* layout */
    ${U}
    padding-inline: ${n[25]} ${n[100]};
    height: 100%;

    /* content */
    fill: ${({theme:e})=>e.action};

    /* appearance */
    background-color: transparent;
    border-radius: 0 99px 99px 0;

    svg {
        margin: -${n[25]};
    }

    &:hover {
        background-color: ${({theme:e})=>e.greyHover};
    }

    &:active {
        background-color: ${({theme:e})=>e.greyPress};
    }

    &:focus-visible {
        outline: ${({theme:e})=>e.focus} solid 2px;
    }
`,ie=Se.span`
    line-height: 1em;
    white-space: nowrap;
`,jn=({as:e,icon:o,defaultIconColor:r,onPress:a,onDelete:i,children:l,pressed:g,...u})=>{let x=e==="item"?Ge.Root:Fe.Item;return g?Co(Yn,{role:"radio","aria-checked":!0,children:[ae(o,{className:"context-icon",color:"inherit"}),ae(ie,{children:l}),ae(St,{...u,as:x,onClick:i,"data-value":u.value,$variant:"medium",children:ae(_,{className:"close-icon",color:"inherit"})})]}):Co(yt,{...u,as:x,onClick:()=>{a(u.value)},"data-value":u.value,$defaultIconColor:r,children:[ae(o,{className:"context-icon",color:"inherit"}),ae(ie,{children:l})]})};import*as Ao from"@radix-ui/react-toggle";import*as Do from"@radix-ui/react-toggle-group";import{useMemo as ta,useState as oa}from"react";import Mo from"styled-components";import{jsx as Io}from"react/jsx-runtime";var ea=e=>Io("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Io("path",{fill:e.color??"currentColor",d:"M11.475 14.475 7.85 10.85a.47.47 0 0 1-.15-.35q0-.2.138-.35.137-.15.362-.15h7.6q.225 0 .363.15t.137.35q0 .05-.15.35l-3.625 3.625a.8.8 0 0 1-.25.175.7.7 0 0 1-.275.05.7.7 0 0 1-.275-.05.8.8 0 0 1-.25-.175"})}),Pt=ea;import{jsx as T,jsxs as Ve}from"react/jsx-runtime";var ra=Mo.section`
    ${vt}
`,na=Mo.button`
    /* reset */
    ${y}

    /* content */
    ${h}

    /* layout */
    ${Y}
    gap: ${n[50]};
    padding-inline: ${n[100]} ${n[25]};
    height: 100%;

    svg {
        margin: -${n[25]};
        fill: ${({theme:e})=>e.iconDefault};
    }
`,aa=({as:e,defaultIconColor:o,disabled:r,icon:a,options:i,pressed:l,onDelete:g,onSelect:u,children:x,...R})=>{let[te,oe]=oa(!1),it=F=>{oe(!1),u(F)},lt=F=>{oe(F)},st=ta(()=>i.find(F=>F.value===R.value),[i,R.value]),ke=e==="item"?Ao.Root:Do.Item;return Ve(I.Root,{open:te,onOpenChange:lt,children:[l?Ve(ra,{role:"radio","aria-checked":!0,children:[T(I.Trigger,{asChild:!0,children:Ve(na,{onClick:()=>{oe(!0)},children:[T(a,{className:"context-icon",color:"inherit"}),T(ie,{children:st?.label}),T(Pt,{className:"expand-icon",color:"inherit"})]})}),T(St,{...R,as:ke,onClick:g,"data-value":R.value,$variant:"medium",children:T(_,{className:"close-icon",color:"inherit"})})]}):T(I.Trigger,{asChild:!0,disabled:r,children:Ve(yt,{...R,as:ke,onClick:()=>{oe(!0)},"data-value":R.value,$defaultIconColor:o,children:[T(a,{className:"context-icon",color:"inherit"}),T(ie,{children:x}),T(Pt,{className:"expand-icon",color:"inherit"})]})}),T(I.Content,{align:"start",children:i.map(F=>{let{value:ge,label:_t,isDisabled:Zt}=F,Qt=l&&R.value===ge;return T(I.Item,{id:ge,onSelect:dt=>{it(dt.target.id)},$selected:Qt,disabled:Zt,children:_t},ge)})})]})};import ia from"styled-components";import{jsx as da}from"react/jsx-runtime";var la=ia(v)`
    /* reset */
    padding: 0;
    border: none;
    height: auto;

    /* layout */
    display: flex;
    gap: ${n[25]};

    /* content */
    color: ${({theme:e})=>e.buttons.link.default};
    text-decoration: underline;
    text-underline-offset: ${n[25]};

    /* appearance */
    &[data-visited='true'] {
        color: ${({theme:e})=>e.buttons.link.used};
    }
    &[data-hovered] {
        color: ${({theme:e})=>e.buttons.link.hover};
    }
    &[data-pressed] {
        color: ${({theme:e})=>e.buttons.link.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        color: ${({theme:e})=>e.buttons.link.disabled};
    }
`,sa=({isVisited:e,children:o,...r})=>da(la,{...r,"data-visited":e,$variant:"medium",children:o});import Le from"styled-components";import pa from"styled-components";var ze=pa(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.primaryDestructive.defaultBackgroud};
    color: ${({theme:e})=>e.buttons.primaryDestructive.defaultContent};
    border-color: ${({theme:e})=>e.buttons.primaryDestructive.defaultBackgroud};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.primaryDestructive.hoverBackground};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.primaryDestructive.pressedBackground};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.primaryDestructive.disabledBackground};
        border-color: ${({theme:e})=>e.buttons.primaryDestructive.disabledBackground};
        color: ${({theme:e})=>e.buttons.primaryDestructive.disabledContent};
    }
`;import ca from"styled-components";var Z=ca(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.primary.default};
    color: ${({theme:e})=>e.buttons.primary.content};
    border-color: ${({theme:e})=>e.buttons.primary.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.primary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.primary.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.primary.disabled};
        color: ${({theme:e})=>e.buttons.primary.disabledContent};
        border-color: ${({theme:e})=>e.buttons.primary.disabled};
    }
`;import ma from"styled-components";var M=ma(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.secondary.default};
    color: ${({theme:e})=>e.accent};
    border-color: ${({theme:e})=>e.accent};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.secondary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.secondary.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        border-color: ${({theme:e})=>e.buttons.secondary.disabledContent};
        background-color: ${({theme:e})=>e.buttons.secondary.default};
        color: ${({theme:e})=>e.buttons.secondary.disabledContent};
    }
`;import ua from"styled-components";var ee=ua(v)`
    /* variants */
    background-color: ${({theme:e})=>e.buttons.teritary.default};
    color: ${({theme:e})=>e.buttons.teritary.content};
    border-color: ${({theme:e})=>e.buttons.teritary.default};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.teritary.hover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.teritary.pressed};
    }
    &[data-disabled],
    &[data-pending] {
        background-color: ${({theme:e})=>e.buttons.teritary.disabled};
        border-color: ${({theme:e})=>e.buttons.teritary.disabled};
        color: ${({theme:e})=>e.buttons.teritary.disabledContent};
    }
`;var ga=Le(Z).attrs({$variant:"large",$fluid:!1})``,fa=Le(M).attrs({$variant:"large",$fluid:!1})``,ha=Le(ze).attrs({$variant:"large",$fluid:!1})``,ba=Le(ee).attrs({$variant:"large",$fluid:!0})``;import{forwardRef as xa}from"react";import ya from"styled-components";var m={small:"600px",medium:"900px",large:"1200px"};import{jsx as Eo}from"react/jsx-runtime";var va=ya(N).attrs({$variant:"small"})`
    @media (max-width: ${m.small}) {
        ${U}

        .button-text {
            display: none;
        }
    }
`,Ho=xa(({text:e,...o},r)=>Eo(va,{...o,ref:r,children:Eo("span",{className:"button-text",children:e})}));Ho.displayName="NavBarButton";import Sa from"styled-components";var Pa=Sa(P)`
    color: ${({theme:e})=>e.buttons.embedded.contentOnDark};

    /* variants */
    &[data-hovered] {
        background-color: ${({theme:e})=>e.buttons.embedded.hoverOnDark};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.buttons.embedded.hoverOnDark};
    }
    &[data-disabled] {
        cursor: not-allowed;
        color: ${({theme:e})=>e.buttons.embedded.disabledContent};
    }
`;import*as B from"@radix-ui/react-dialog";import Fo from"styled-components";import{jsx as Go,jsxs as Ca}from"react/jsx-runtime";var $a=Fo(B.Overlay)`
    /* layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* appearance */
    background-color: ${({theme:e})=>e.backdrop};
`,wa=Fo(B.Content)`
    /* reset */
    user-select: none;

    /* layout */
    position: fixed;
    bottom: 0;
    left: 0;
    height: auto;
    max-height: 60vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.large} ${d.large} 0 0;
    outline: none;
`,Ta=B.Root,Ba=B.Trigger,Vo=B.Title,zo=({children:e})=>Ca(B.Portal,{children:[Go($a,{}),Go(wa,{children:e})]});import*as qe from"@radix-ui/react-checkbox";import Wo from"styled-components";import{jsx as Lo}from"react/jsx-runtime";var ka=e=>Lo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Lo("path",{fill:e.color??"currentColor",d:"m10.6 13.4-2.15-2.15a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7L9.9 15.5q.3.3.7.3t.7-.3l5.65-5.65a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275zM5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"})}),qo=ka;import{jsx as $t,jsxs as Da}from"react/jsx-runtime";var Ra=Wo.label`
    /* reset */
    cursor: pointer;
    user-select: none;

    /* content */
    ${h}

    /* layout */
    display: flex;
    align-items: center;
    gap: 0.5em;

    color: ${({theme:e})=>e.checkbox.defaultText};

    /* appearance */
    &:has([data-disabled]) {
        cursor: not-allowed;
        color: ${({theme:e})=>e.checkbox.disabled};
    }

    &:hover:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.checkbox.hover};
    }

    &:active:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.checkbox.pressed};
    }
`,Ia=Wo(qe.Root)`
    /* reset */
    ${y}
    position: relative;

    /* layout */
    width: 1.5rem;
    height: 1.5rem;
    box-sizing: border-box;

    /* appearance */
    color: ${({theme:e})=>e.checkbox.defaultFill};
    &[data-disabled] {
        cursor: not-allowed;
        color: ${({theme:e})=>e.checkbox.disabled};
    }

    &:hover:not(:has([data-disabled])) {
        color: ${({theme:e})=>e.checkbox.hover};
    }

    // adding a symbol for unchecked state
    &:after {
        /* reset */
        content: '';
        box-sizing: border-box;

        /* layout */
        top: 0.25rem;
        left: 0.25rem;
        position: absolute;
        width: 1rem;
        height: 1rem;

        /* appearance */
        border-radius: 1px;
        outline-width: 2px;
        // we need one pixel on either side of the outline
        outline-offset: -1px;
        outline-style: solid;
        outline-color: inherit;
    }
`,Aa=({name:e,children:o,...r})=>Da(Ra,{htmlFor:e,children:[$t(Ia,{...r,name:e,children:$t(qe.Indicator,{children:$t(qo,{color:"currentColor"})})}),o]});import*as We from"@radix-ui/react-toggle-group";import Uo from"styled-components";import{jsx as wt,jsxs as Oo}from"react/jsx-runtime";var Ma=Uo(Vo)`
    /* reset */
    cursor: default;
    font-weight: normal;
    font-style: normal;
    font-size: 1rem;
    margin: 0;

    /* content */
    ${he}
    color: ${({theme:e})=>e.notes};

    /* layout */
    height: ${w.large};
    display: flex;
    align-items: center;
    padding-inline: ${s.horizontalComponentGap};
`,Ea=Uo(We.Item)`
    /* reset */
    ${ne}
    border: none;

    /* content */
    ${h}
    color: ${({theme:e})=>e.secondaryText};
    &[data-state='on'] {
        color: ${({theme:e})=>e.accent};
    }
`,Ha=({title:e,children:o,...r})=>Oo(zo,{children:[wt(Ma,{children:e}),wt(We.Root,{type:"single",...r,children:o})]}),Ga=({icon:e,children:o,...r})=>Oo(Ea,{...r,children:[wt(e,{color:"currentcolor"}),o]});import*as E from"@radix-ui/react-context-menu";import{forwardRef as No}from"react";import _o from"styled-components";import{jsx as Tt,jsxs as La}from"react/jsx-runtime";var Fa=_o(E.Content)`
    ${Me}
`,Va=_o(E.Item)`
    ${ne}
`,Zo=No(({children:e,icon:o,...r},a)=>La(Va,{...r,ref:a,children:[o&&Tt(o,{}),e]}));Zo.displayName="ContextMenuItem";var Qo=No(({children:e,...o},r)=>Tt(E.Portal,{children:Tt(Fa,{...o,ref:r,children:e})}));Qo.displayName="ContextMenuContent";var za={Root:E.Root,Trigger:E.Trigger,Content:Qo,Item:Zo};import ir from"styled-components";import{jsx as Xo}from"react/jsx-runtime";var qa=e=>Xo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Xo("path",{fill:e.color??"currentColor",d:"m9.55 15.15 8.475-8.475q.3-.3.713-.3.412 0 .712.3t.3.713q0 .411-.3.712l-9.2 9.2q-.3.3-.7.3a.96.96 0 0 1-.7-.3L4.55 13a.93.93 0 0 1-.288-.713 1.02 1.02 0 0 1 .313-.712q.3-.3.712-.3.413 0 .713.3z"})}),Ue=qa;import{jsx as Ko}from"react/jsx-runtime";var Wa=e=>Ko("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Ko("path",{fill:"#9E9E9E",d:"M22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6M4 8h16V6H4zm0 4v6h16v-6z"})}),Bt=Wa;import{jsx as Pe,jsxs as Oa}from"react/jsx-runtime";var Ua=e=>Oa("svg",{xmlns:"http://www.w3.org/2000/svg",width:96,height:96,fill:e.color??"currentColor",viewBox:"0 0 96 96",...e,children:[Pe("g",{clipPath:"url(#a)",children:Pe("path",{fill:e.color??"currentColor",d:"M22 70q-9.2 0-15.6-6.4T0 48t6.4-15.6T22 26q3.7 0 7.1 1.3t6.1 3.7l6.8 6.2-6 5.4-6.2-5.6a12.4 12.4 0 0 0-3.6-2.2A11.2 11.2 0 0 0 22 34q-5.8 0-9.9 4.1T8 48t4.1 9.9T22 62q2.2 0 4.2-.8a12.4 12.4 0 0 0 3.6-2.2l31-28q2.7-2.4 6.1-3.7A19.7 19.7 0 0 1 74 26q9.2 0 15.6 6.4T96 48t-6.4 15.6T74 70q-3.7 0-7.1-1.3T60.8 65L54 58.8l6-5.4 6.2 5.6a12.4 12.4 0 0 0 3.6 2.2q2 .8 4.2.8 5.8 0 9.9-4.1T88 48t-4.1-9.9T74 34q-2.2 0-4.2.8a12.4 12.4 0 0 0-3.6 2.2l-31 28a19.7 19.7 0 0 1-6.1 3.7A19.7 19.7 0 0 1 22 70"})}),Pe("defs",{children:Pe("clipPath",{id:"a",children:Pe("path",{fill:"#fff",d:"M0 0h96v96H0z"})})})]}),Ct=Ua;import{jsx as $e,jsxs as _a}from"react/jsx-runtime";var Na=e=>_a("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:[$e("path",{fill:e.color??"currentColor",d:"M22.72 4H1.28C.573 4 0 4.608 0 5.359V18.64C0 19.391.573 20 1.28 20h21.44c.707 0 1.28-.608 1.28-1.359V5.36C24 4.609 23.427 4 22.72 4"}),$e("path",{fill:"#fff",d:"M7.076 18.106v-.815c0-.313-.185-.517-.49-.517a.52.52 0 0 0-.45.23.46.46 0 0 0-.425-.23.45.45 0 0 0-.384.19V16.8h-.251v1.305h.252v-.747c0-.23.132-.34.318-.34.185 0 .291.123.291.34v.748h.252v-.748c0-.23.132-.34.318-.34s.292.123.292.34v.748zm4.135-1.291h-.464v-.394h-.25v.394h-.266v.23h.265v.612c0 .3.106.476.424.476a.7.7 0 0 0 .344-.095l-.08-.23a.43.43 0 0 1-.238.068c-.133 0-.199-.081-.199-.217v-.625h.464v-.219m2.36-.041a.4.4 0 0 0-.345.19V16.8h-.252v1.305h.252v-.733c0-.217.106-.353.278-.353a.8.8 0 0 1 .172.027l.08-.245a1 1 0 0 0-.186-.027m-3.566.136c-.132-.095-.318-.136-.517-.136-.318 0-.516.15-.516.408 0 .218.146.34.424.38l.132.014c.146.027.239.082.239.15 0 .095-.106.164-.305.164a.7.7 0 0 1-.424-.136l-.133.204c.186.136.411.164.544.164.372 0 .57-.177.57-.421 0-.23-.16-.34-.437-.381l-.133-.014c-.119-.013-.224-.054-.224-.136 0-.095.106-.164.252-.164.16 0 .318.068.398.109zm3.844.544c0 .393.252.68.662.68.186 0 .319-.041.451-.15l-.132-.204a.53.53 0 0 1-.332.122c-.224 0-.397-.176-.397-.434 0-.259.171-.434.397-.434.121.001.238.044.332.122l.132-.203a.65.65 0 0 0-.45-.15c-.398-.027-.663.258-.663.652zm-1.776-.68c-.371 0-.623.272-.623.68s.265.68.649.68a.8.8 0 0 0 .517-.177l-.133-.19a.62.62 0 0 1-.37.135.375.375 0 0 1-.385-.34h.941v-.108c0-.408-.239-.68-.596-.68m-.013.245c.185 0 .318.122.33.326h-.688c.04-.19.16-.326.358-.326M8.627 16.8h-.252v.164a.48.48 0 0 0-.41-.19c-.358 0-.624.286-.624.68s.265.68.623.68a.48.48 0 0 0 .411-.191v.164h.252zm-1.02.653c0-.245.145-.435.397-.435.239 0 .384.19.384.435 0 .258-.16.435-.384.435-.252.013-.397-.19-.397-.435m9.794-.68a.4.4 0 0 0-.344.19V16.8h-.252v1.305h.251v-.733c0-.217.106-.353.278-.353a.8.8 0 0 1 .173.027l.08-.245a1 1 0 0 0-.186-.027m-.98.027h-.252v.164a.48.48 0 0 0-.411-.19c-.358 0-.623.286-.623.68s.264.68.623.68a.48.48 0 0 0 .41-.191v.164h.252zm-1.021.653c0-.245.146-.435.398-.435.238 0 .384.19.384.435 0 .258-.16.435-.384.435-.252.013-.398-.19-.398-.435m3.578-1.17h-.252v.68a.48.48 0 0 0-.41-.19c-.358 0-.623.285-.623.68 0 .394.265.68.623.68a.48.48 0 0 0 .41-.19v.163h.252zm-1.02 1.17c0-.245.146-.435.398-.435.238 0 .384.19.384.435 0 .258-.16.435-.384.435-.253.013-.398-.19-.398-.435"}),$e("path",{fill:"#FF5F00",d:"M14.313 6.905h-4.6V14.6h4.6z"}),$e("path",{fill:"#EB001B",d:"M10.178 10.752c0-1.5.669-2.916 1.815-3.847a4.686 4.686 0 0 0-6.454.527 4.986 4.986 0 0 0 0 6.64 4.686 4.686 0 0 0 6.454.527 4.95 4.95 0 0 1-1.815-3.847"}),$e("path",{fill:"#F79E1B",d:"M19.72 10.752c.002 1.872-1.04 3.581-2.681 4.4a4.67 4.67 0 0 1-5.03-.553 4.95 4.95 0 0 0 1.815-3.847c0-1.5-.669-2.917-1.815-3.847a4.67 4.67 0 0 1 5.03-.553c1.641.82 2.683 2.528 2.682 4.4"})]}),Jo=Na;import{jsx as Yo}from"react/jsx-runtime";var Za=e=>Yo("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:Yo("path",{fill:e.color??"currentColor",d:"M5 19h1.425L16.2 9.225 14.775 7.8 5 17.575zm-1 2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20v-2.425a1.98 1.98 0 0 1 .575-1.4L16.2 3.575q.3-.275.663-.425.362-.15.762-.15t.775.15.65.45L20.425 5q.3.275.438.65a2.17 2.17 0 0 1 0 1.512 1.9 1.9 0 0 1-.438.663l-12.6 12.6a1.975 1.975 0 0 1-1.4.575zM15.475 8.525l-.7-.725L16.2 9.225z"})}),jo=Za;import{jsx as er}from"react/jsx-runtime";var Qa=e=>er("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:er("path",{fill:e.color??"currentColor",d:"M15.5 11q.624 0 1.063-.437Q17 10.125 17 9.5t-.437-1.062A1.45 1.45 0 0 0 15.5 8q-.625 0-1.062.438A1.45 1.45 0 0 0 14 9.5q0 .624.438 1.063.437.437 1.062.437m-7 0q.624 0 1.063-.437Q10 10.125 10 9.5t-.437-1.062A1.45 1.45 0 0 0 8.5 8q-.625 0-1.062.438A1.45 1.45 0 0 0 7 9.5q0 .624.438 1.063Q7.875 11 8.5 11m3.5 2.5q-1.7 0-3.088.963A5.5 5.5 0 0 0 6.9 17h1.65a4.1 4.1 0 0 1 1.462-1.463A3.85 3.85 0 0 1 12 15q1.076 0 1.988.537A4.1 4.1 0 0 1 15.45 17h1.65a5.5 5.5 0 0 0-2.013-2.537A5.3 5.3 0 0 0 12 13.5m0 8.5a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"})}),tr=Qa;import{jsx as kt,jsxs as Ka}from"react/jsx-runtime";var Xa=e=>Ka("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:[kt("path",{fill:"#0E4595",d:"M1.23 4h21.54c.679 0 1.23.573 1.23 1.28v13.44c0 .707-.551 1.28-1.23 1.28H1.23C.552 20 0 19.427 0 18.72V5.28C0 4.573.551 4 1.23 4"}),kt("path",{fill:"#fff",d:"m9.022 15.128 1.026-6.177h1.642l-1.027 6.177zm7.572-6.044a4.2 4.2 0 0 0-1.471-.26c-1.622 0-2.765.838-2.775 2.039-.01.888.816 1.383 1.439 1.678.639.303.853.496.85.767-.004.414-.51.603-.982.603-.657 0-1.006-.094-1.545-.324l-.212-.098-.23 1.383c.383.172 1.092.321 1.829.33 1.726 0 2.846-.83 2.859-2.111.006-.703-.432-1.238-1.379-1.679-.574-.286-.925-.477-.921-.766 0-.257.297-.531.94-.531.537-.009.926.111 1.229.236l.147.072zm4.225-.134h-1.268c-.393 0-.688.11-.86.513l-2.438 5.661h1.724s.281-.761.345-.928l2.103.003c.049.216.2.925.2.925h1.523zm-2.013 3.99c.136-.356.654-1.727.654-1.727-.01.016.135-.358.218-.59l.111.533.38 1.784zM7.628 8.95 6.02 13.164l-.17-.857c-.3-.987-1.232-2.056-2.275-2.591l1.47 5.403 1.737-.002L9.367 8.95z"}),kt("path",{fill:"#F2AE14",d:"M4.52 8.827H1.874l-.02.129c2.059.511 3.422 1.747 3.987 3.232l-.575-2.84c-.1-.39-.388-.507-.744-.52"})]}),or=Xa;import{jsx as rr}from"react/jsx-runtime";var Ja=e=>rr("svg",{xmlns:"http://www.w3.org/2000/svg",width:24,height:24,fill:e.color??"currentColor",viewBox:"0 0 24 24",...e,children:rr("path",{fill:e.color??"currentColor",d:"M2.725 21a.973.973 0 0 1-.85-.5 1.1 1.1 0 0 1-.137-.488.9.9 0 0 1 .137-.512l9.25-16q.15-.25.387-.375T12 3t.488.125a1 1 0 0 1 .387.375l9.25 16q.15.25.137.512a1.1 1.1 0 0 1-.137.488.97.97 0 0 1-.85.5zm1.725-2h15.1L12 6zM12 18q.424 0 .713-.288A.97.97 0 0 0 13 17a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 16a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 17q0 .424.287.712.288.288.713.288m0-3q.424 0 .713-.287A.97.97 0 0 0 13 14v-3a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 10a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 11v3q0 .424.287.713.288.287.713.287"})}),nr=Ja;import Ya from"styled-components";import{jsx as ei,jsxs as ti}from"react/jsx-runtime";var Rt=Ya.div`
    height: 2rem;
    width: 100%;
    display: grid;
    place-content: center;
    border-radius: 100px;
    color: ${({theme:e})=>e.dataUsageBar.used};
    font-size: 6rem;

    background: linear-gradient(
        to right,
        ${({theme:e})=>e.dataUsageBar.used} ${({$completePercent:e})=>e}%,
        ${({theme:e})=>e.dataUsageBar.total} ${({$completePercent:e})=>e}%
    );
`,ja=({value:e})=>ti(c.Paragraph,{as:"label",children:[e,"%",ei(Rt,{$completePercent:e,role:"progressbar","aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":e})]});import le from"styled-components";var It=le(c.Paragraph).attrs({as:"section"})`
    display: flex;
    justify-content: space-between;
`,oi=le(It)`
    justify-content: center;
`,ar=le.li`
    ${W}
`,At=le.ul`
    all: unset;
    display: flex;
    flex-direction: row;
    column-gap: 0.5rem;
    list-style: none;

    & > li::before {
        content: '•';
        margin-right: 0.5rem;
    }

    & > li:first-child::before {
        content: '';
        margin-right: 0;
    }
`,ri=le(At)`
    padding-left: ${s.horizontalComponentGap};

    column-gap: 1rem;
    text-align: center;

    & > li::before {
        margin-right: 1rem;
    }

    @media (max-width: ${m.small}) {
        column-gap: 1.5rem;

        & > li::before {
            content: none;
            margin-right: 0.5rem;
        }
    }
`,ni=le.span`
    font-weight: 700;

    &:after {
        content: ' ';
    }

    @media (max-width: ${m.small}) {
        display: block;
        &:after {
            content: '';
        }
    }
`,ai={Section:oi,Descriptions:ri,CountSize:ni};import{jsx as Oe,jsxs as we}from"react/jsx-runtime";var ii=ir.div.attrs({role:"none"})`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`,li=ir(c.Subheader)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.25rem;
`,si=({used:e,max:o,usage:r,totalQuota:a,usageDescriptions:i})=>{let l=o===0||o===1/0?0:Math.min(e/o*100,100),[g,u]=r,[x,R]=a;return we(ii,{children:[we(li,{as:"label",htmlFor:"data_usage_bar",children:[g," ",u]}),we(Rt,{$completePercent:l!==0?Math.max(l,5):l,role:"meter","aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":l,id:"data_usage_bar",children:[o===0&&0,o===1/0&&Oe(Ct,{})]}),we(It,{children:[Oe(At,{children:i.map(te=>Oe(ar,{children:te},te))}),we(c.Paragraph,{children:[Oe(c.Bold,{children:x})," ",R]})]})]})};import di from"styled-components";import{jsx as lr,jsxs as mi}from"react/jsx-runtime";var pi=di.main`
    display: grid;
    place-content: center;
    justify-items: center;
    gap: 0.5rem;
    height: 100%;
`,ci=({children:e})=>mi(pi,{children:[lr(c.Subheader,{children:e}),lr(tr,{width:48,height:48})]});import Dt,{useTheme as ui}from"styled-components";import{jsx as Ne,jsxs as xi}from"react/jsx-runtime";var gi=Dt.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-flow: row;
    align-items: center;
    column-gap: ${n[75]};
    row-gap: ${n[25]};
`,fi=Dt.dd`
    /* reset */
    margin: 0;

    /* layout */
    grid-column: 2;

    /* content */
    ${W}
`,hi=Dt.dd`
    /* reset */
    margin: 0;

    /* layout */
    grid-column: 2;

    > *:not(:first-child)::before {
        content: '•';
        margin-inline: ${n[50]};
    }

    /* content */
    ${be}
    color: ${({theme:e})=>e.secondaryText};
`,bi=({icon:e,mainText:o,subTexts:r=[]})=>{let a=ui(),i=!!o;return xi(gi,{children:[Ne(e,{color:a.iconDefault}),i&&Ne(fi,{children:o}),Ne(hi,{children:r.map(l=>Ne("span",{children:l},l))})]})};import Mt from"styled-components";import{jsx as sr,jsxs as dr}from"react/jsx-runtime";var yi="360px",vi="56px",Si=Mt.aside`
    /* layout */
    width: ${yi};
    height: 100vh;
    display: flex;
    flex-direction: column;

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    box-shadow: ${uo} ${({theme:e})=>e.menu.shadow};

    // take the whole screen in mobile views
    @media (max-width: ${m.small}) {
        width: 100vw;
    }
`,Pi=Mt.header`
    /* reset */
    box-sizing: border-box;

    /* layout */
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: ${vi};
    border-bottom: 1px solid ${({theme:e})=>e.stroke.light};
    padding-inline: ${n[100]} ${n[75]};
`,$i=Mt.dl`
    /* reset */
    margin: 0;

    /* layout */
    padding: ${n[150]} ${n[75]};
    overflow: auto;

    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${n[150]};
`,wi=({title:e,onClose:o,children:r,...a})=>dr(Si,{...a,children:[dr(Pi,{children:[e,sr(P,{onPress:o,icon:_})]}),sr($i,{children:r})]});import*as S from"@radix-ui/react-form";import{forwardRef as Ti}from"react";import se from"styled-components";import{Fragment as Fi,jsx as Te,jsxs as pr}from"react/jsx-runtime";var Bi=se(S.Field)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;

    min-height: 96px; /* we want to pre-occupy the space for error message */
    @media (max-width: ${m.small}) {
        min-height: 84px;
    }
`,Ci=se(S.Label)`
    padding-left: ${s.innerGap};

    font-weight: 700;
    ${be}
    color: ${({theme:e})=>e.notes};

    &[data-invalid] {
        color: ${({theme:e})=>e.alert};
    }
`,ki=se.span`
    color: ${({theme:e})=>e.alert};
`,Ri=se.input`
    padding-left: ${s.innerGap};

    outline: none;
    box-sizing: border-box;
    border-radius: ${d.small};
    border: 1px solid ${({theme:e})=>e.stroke.light};

    ${he}
    line-height: ${w.large};
    width: 100%;

    ::placeholder {
        color: ${({theme:e})=>e.notes};
    }

    &:focus {
        border: 1px solid ${({theme:e})=>e.accent};
    }

    &[data-invalid] {
        border: 1px solid ${({theme:e})=>e.alert};
    }

    :-webkit-autofill {
        -webkit-background-clip: text;
    }
`,cr=se(S.Message)`
    padding-left: ${s.innerGap};

    ${be}
    color: ${({theme:e})=>e.notes};
`,Ii=se(cr)`
    color: ${({theme:e})=>e.alert};
`,Ai=({name:e,label:o,required:r,children:a,...i})=>pr(Bi,{...i,name:e,children:[pr(Ci,{children:[o,r&&Te(ki,{children:" *"})]}),a]}),Di=({errorMatchers:e})=>Te(Fi,{children:e.map(([o,r])=>Te(Ii,{match:o,children:r},r))}),mr=Ti(({...e},o)=>Te(S.Control,{asChild:!0,children:Te(Ri,{...e,ref:o})}));mr.displayName="InputField";var Mi=S.Root,Ei=S.Submit,Hi=S.ValidityState,Gi={Root:Mi,Field:Ai,ValidityState:Hi,ErrorMessage:Di,HintMessage:cr,Input:mr,Submit:Ei};import Ze,{keyframes as Vi}from"styled-components";import{jsx as _e,jsxs as Oi}from"react/jsx-runtime";var zi=Vi`
    0% {
        transform: scale(0);
        opacity: 0;
    }
    33% {
        transform: scale(0.44);
        opacity: 1;
    }
    100% {
        transform: scale(0.88);
        opacity: 0;
    }
`,Li=Ze.div.attrs({"aria-hidden":!0})`
    /* reset */
    // we leverage font-size to have the circles scale
    font-size: ${({size:e})=>e}rem;

    /* layout */
    width: ${({size:e})=>e}rem;
    height: ${({size:e})=>e}rem;
    position: relative;
`,ur=Ze.div`
    /* reset */
    box-sizing: border-box;

    /* layout */
    position: absolute;
    width: 100%;
    height: 100%;

    /* appearance */
    opacity: 0;
    border-radius: 50%;
    border: 0.125em solid ${({theme:e})=>e.accent};
    animation: ${zi} 1.3s ease-out infinite;
`,qi=Ze(ur)`
    /* appearance */
    border: 0.125em solid ${({theme:e})=>e.accent};
    animation-delay: 0.65s;
`,Wi=Ze.section`
    display: grid;
    place-content: center;
    height: 100%;
`,gr=({size:e=1.5})=>Oi(Li,{size:e,children:[_e(ur,{}),_e(qi,{})]}),Ui=()=>_e(Wi,{children:_e(gr,{size:4})});import Ni from"styled-components";var _i=Ni.section`
    width: 640px;
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.small};
    box-sizing: border-box;
    padding: 1rem;
    padding-bottom: 2rem;

    margin-top: 2rem;
    height: fit-content;

    @media (max-width: ${m.small}) {
        /* layout */
        margin: 1rem;
    }
`;import Zi from"styled-components";var Qi=Zi.section`
    width: 310px;
    height: 134px;

    padding: ${n[50]} 0px;

    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.medium};
    box-shadow: ${({theme:e})=>`${re} ${e.menu.shadow}`};

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;
    color: ${({theme:e})=>e.accent};

    @media (max-width: ${m.small}) {
        width: 186px;
        height: 144px;
    }
`;import*as $ from"@radix-ui/react-dialog";import C,{css as Xi}from"styled-components";import{Fragment as cl,jsx as z,jsxs as Qe}from"react/jsx-runtime";var Ki=C($.Overlay)`
    /* layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    /* appearance */
    background-color: ${({theme:e})=>e.backdrop};
`,Ji=C($.Content)`
    /* reset */
    box-sizing: border-box;

    /* layout */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: ${({$flowPrompt:e})=>e?"640px":"512px"};
    max-height: 96%;
    padding: ${n[200]};
    display: flex;
    flex-direction: column;
    gap: ${n[200]};

    /* appearance */
    background-color: ${({theme:e})=>e.menu.fill};
    border-radius: ${d.small};
    outline: none;

    @media (max-width: ${m.small}) {
        /* layout */
        // in small screens we leave 1rem on each side
        width: calc(100% - ${n[200]});
    }
`,Yi=C.header`
    /* layout */
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`,ji=C($.Title)`
    display: flex;
    gap: ${s.innerGap};
    align-items: center;
`,fr=C.form`
    display: grid;
    gap: ${n[200]};
    overflow-y: auto;
`,el=C.section`
    /* layout */
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: ${s.horizontalComponentGap};

    @media (max-width: ${m.small}) {
        /* layout */
        flex-direction: column-reverse;
    }
`,hr=$.Root,br=$.Trigger,xr=({title:e,icon:o,flowPrompt:r=!1,preventCloseOnClickOutside:a=!1,hideCloseButton:i=!1,children:l,...g})=>Qe(cl,{children:[z(Ki,{}),Qe(Ji,{...g,"aria-describedby":void 0,$flowPrompt:r,onInteractOutside:a?u=>{u.preventDefault()}:void 0,children:[Qe(Yi,{children:[Qe(ji,{children:[o,z(c.SectionHeader,{as:"span",children:e})]}),!i&&z($.DialogClose,{asChild:!0,children:z(P,{icon:_})})]}),l]})]}),Et=Xi`
    @media (max-width: ${m.small}) {
        /* layout */
        width: 100%;
    }
`,tl=C(Z).attrs({$variant:"large"})`
    /* layout */
    ${Et}
`,ol=C(M).attrs({$variant:"large"})`
    /* layout */
    ${Et}
`,rl=C(ze).attrs({$variant:"large"})`
    /* layout */
    ${Et}
`,yr=({children:e,variant:o,closeOnSubmit:r=!0,...a})=>{let i=(()=>{switch(o){case"primary":return tl;case"secondary":return ol;case"destructive":return rl}})();return r&&a.type!=="submit"?z($.DialogClose,{asChild:!0,children:z(i,{...a,children:e})}):z(i,{...a,children:e})},nl=C(nr)`
    color: ${({theme:e})=>e.alert};
`,al=C(c.Secondary)`
    display: flex;
    justify-content: flex-end;
    margin-top: -1.75rem;

    color: ${({theme:e})=>e.alert};

    @media (max-width: ${m.small}) {
        justify-content: flex-start;
        margin-top: -${n[150]};
    }
`,il={ActionButton:yr,ActionErrorMessage:al,ButtonsSection:el,Content:xr,Form:fr,Root:hr,Trigger:br,WarningIcon:nl},ll=C.section`
    display: grid;
    gap: ${s.horizontalComponentGap};
`,sl=({children:e,...o})=>z(xr,{...o,flowPrompt:!0,children:e});function dl({children:e,variant:o,...r}){return z(yr,{variant:o,$fluid:!0,...r,children:e})}var pl={ActionButton:dl,IconButton:P,ButtonsSection:ll,Content:sl,Form:fr,Root:hr,Trigger:br};import*as Xe from"@radix-ui/react-switch";import Ht from"styled-components";import{jsx as vr,jsxs as hl}from"react/jsx-runtime";var ml=Ht(Xe.Root)`
    /* reset */
    transition: background-color 0.3s;
    border: none;
    cursor: pointer;

    /* layout */
    position: relative;
    width: 2.25rem;
    height: 1rem;

    /* appearance */
    background-color: ${({theme:e})=>e.toggle.off.defaultTrack};
    border-radius: ${d.round};

    &[data-state='checked'] {
        background-color: ${({theme:e})=>e.toggle.on.defaultTrack};
    }

    &[data-disabled] {
        cursor: not-allowed;
        background-color: ${({theme:e})=>e.toggle.off.disabledTrack};
    }
    &[data-state='checked'][data-disabled] {
        background-color: ${({theme:e})=>e.toggle.on.disabledTrack};
    }

    &:hover:not(:has([data-disabled])) {
        background-color: ${({theme:e})=>e.toggle.off.hoverTrack};
        span {
            background-color: ${({theme:e})=>e.toggle.off.hoverHandle};
        }

        &[data-state='checked'] {
            background-color: ${({theme:e})=>e.toggle.on.hoverTrack};
            span {
                background-color: ${({theme:e})=>e.toggle.on.hoverHandle};
            }
        }
    }
`,ul=Ht(Xe.Thumb)`
    /* reset */
    transition-property: transform, background-color;
    transition-duration: 0.3s;
    will-change: transform;

    /* layout */
    position: absolute;
    top: -0.125rem; // (track height - thumb height) / 2
    left: 0;
    width: 1.25rem;
    height: 1.25rem;

    /* appearance */
    background-color: ${({theme:e})=>e.toggle.off.defaultHandle};
    border-radius: ${d.round};
    box-shadow: ${go} ${({theme:e})=>e.toggle.shadow};

    &[data-state='checked'] {
        background-color: ${({theme:e})=>e.toggle.on.defaultHandle};
        transform: translateX(1rem);
    }

    &[data-disabled] {
        cursor: not-allowed;
        background-color: ${({theme:e})=>e.toggle.off.disabledHandle};
    }

    &[data-state='checked'][data-disabled] {
        background-color: ${({theme:e})=>e.toggle.on.disabledHandle};
    }
`,gl=Ht.label`
    /* reset */
    cursor: pointer;
    user-select: none;
    transition: color 0.3s;

    /* content */
    ${h}

    /* layout */
    display: flex;
    align-items: center;
    gap: 1rem;

    color: ${({theme:e})=>e.mainText};

    /* appearance */
    &:has([data-disabled]) {
        cursor: not-allowed;
        color: ${({theme:e})=>e.disabledContent};
    }
`,fl=({children:e,name:o,...r})=>hl(gl,{htmlFor:o,children:[vr(ml,{...r,name:o,children:vr(ul,{})}),e]});import*as Ke from"@radix-ui/react-tooltip";import Gt from"styled-components";import bl from"styled-components";var Sr=bl(N)`
    /* variants */
    color: ${({theme:e})=>e.accent};

    &[data-hovered] {
        background-color: ${({theme:e})=>e.blueHover};
    }
    &[data-pressed] {
        background-color: ${({theme:e})=>e.bluePress};
    }
`;var Je=Gt(Ke.Content)`
    /* layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    max-width: 400px;
    padding: ${n[25]};

    /* content */
    ${h}
    color: ${({theme:e})=>e.tooltips.content};

    /* appearance */
    background-color: ${({theme:e})=>e.tooltips.fill};
    border-radius: ${d.small};
    outline: none;
    box-shadow: ${({theme:e})=>`${re} ${e.tooltips.shadow}`};

    @media (max-width: ${m.small}) {
        /* layout */
        max-width: calc(100vw - 2 * ${n[100]});
        flex-direction: column;
    }
`,Ye=Gt.p`
    margin: 0;
    padding: ${n[25]} ${n[50]};
`,Pr=Gt(Sr).attrs({$variant:"small"})`
    align-self: end;
`,xl=Ke.Provider;import*as de from"@radix-ui/react-tooltip";import{useState as yl}from"react";import vl from"styled-components";import{jsx as je,jsxs as $r}from"react/jsx-runtime";var Sl=vl(de.Trigger)`
    padding: 0;
    border: 0;
    background-color: transparent;
`;function Pl({children:e,description:o,actionButtonText:r,onActionButtonClick:a,openDelay:i=500,...l}){let[g,u]=yl(!1);return $r(de.Root,{delayDuration:i,open:g,onOpenChange:u,children:[je(Sl,{onClick:()=>{u(x=>!x)},onFocus:()=>setTimeout(()=>{u(!0)},0),onBlur:x=>{x.preventDefault()},children:e}),je(de.Portal,{children:$r(Je,{side:"bottom",sideOffset:4,collisionPadding:8,...l,children:[je(Ye,{children:o}),je(Pr,{onPress:a,children:r})]})})]})}import*as H from"@radix-ui/react-tooltip";import{useEffect as $l,useState as wl}from"react";import ce from"styled-components";import{jsx as pe,jsxs as wr}from"react/jsx-runtime";var Tl=ce(H.Trigger)`
    padding: 0;
    border: 0;
    background-color: transparent;
`,Bl=ce(Je)`
    padding: ${n[75]} ${n[100]};
    flex-direction: column;
    background-color: ${({theme:e})=>e.hint.fill};
    color: ${({theme:e})=>e.hint.content};
    z-index: ${({$zIndex:e})=>e??"auto"};
`,Cl=ce(Ye)`
    align-self: flex-start;
    padding: 0;
`,kl=ce.section`
    height: 1px;
    width: 100%;
    background-color: ${({theme:e})=>e.hint.content};
    margin: ${n[50]} 0;
`,Rl=ce(N).attrs({$variant:"small"})`
    min-width: fit-content;
    align-self: end;
    justify-self: flex-end;
    color: ${({theme:e})=>e.hint.content};
`,Il=ce(H.Arrow)`
    fill: ${({theme:e})=>e.hint.fill};
`,Al=H.Provider;function Dl({children:e,description:o,actionButtonText:r,onActionButtonClick:a,zIndex:i,...l}){let[g,u]=wl(!0);return $l(()=>{u(!0)},[]),wr(H.Root,{delayDuration:0,open:g,children:[pe(Tl,{asChild:!0,children:e}),pe(H.Portal,{children:wr(Bl,{side:"bottom",sideOffset:4,collisionPadding:8,forceMount:!0,$zIndex:i,...l,children:[pe(Il,{}),pe(Cl,{children:o}),pe(kl,{}),pe(Rl,{onPress:()=>{a()},children:r})]})})]})}import Tr from"styled-components";import{jsx as Ft}from"react/jsx-runtime";var Ml=Tr.span`
    /* reset */
    ${y}

    /* layout */
    ${Y}
    padding-inline: 0;
    justify-content: center;

    /* appearance */
    ${xe}
    width: ${J("small")};
    min-width: ${J("small")};
    height: ${J("small")};

    background-color: transparent;
    color: ${({theme:e})=>e.buttons.embedded.contentOnDark};
    border-color: transparent;
`,El=Tr(v).attrs({$variant:"medium"})`
    background: transparent;
    padding: 0 ${n[75]};

    border-radius: 0;
    border-width: 0;
    border-style: none;

    width: ${({$width:e})=>e};
    height: ${({$height:e})=>e};

    ${({$iconPosition:e})=>{switch(e){case"left":return"justify-content: flex-start;";case"right":return"justify-content: flex-end;"}}}

    &[data-hovered] .iconWrapper {
        background-color: ${({theme:e})=>e.buttons.embedded.hoverOnDark};
    }
    &[data-pressed] .iconWrapper {
        background-color: ${({theme:e})=>e.buttons.embedded.pressedOnDark};
    }
    &[data-disabled] .iconWrapper {
        cursor: not-allowed;
        color: ${({theme:e})=>e.buttons.embedded.disabledContent};
    }
`,Hl=({icon:e,width:o,height:r,iconPosition:a,...i})=>Ft(El,{...i,$width:o,$height:r,$iconPosition:a,children:Ft(Ml,{className:"iconWrapper",children:Ft(e,{color:"currentColor"})})});import Wl from"styled-components";import*as me from"@radix-ui/react-radio-group";import{forwardRef as Gl}from"react";import et from"styled-components";import{jsx as Vt,jsxs as ql}from"react/jsx-runtime";var Fl=et.div`
    ${y}

    display: flex;
    align-items: flex-start;
`,Vl=et(me.Item)`
    all: unset;

    width: 16px;
    height: 16px;
    /* prevent icon from resizing on screen width change */
    min-width: 16px;
    min-height: 16px;

    border-radius: 100%;
    border: 1px solid ${({theme:e})=>e.radioButton.defaultFill};
    background-color: white;

    &:hover,
    &:focus {
        border: 1px solid ${({theme:e})=>e.radioButton.hover};
    }
`,zl=et(me.Indicator)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    width: 100%;
    height: 100%;

    &::after {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${({theme:e})=>e.radioButton.defaultFill};
    }
`,Ll=et.label`
    cursor: pointer;
    user-select: none;
    margin-left: ${s.innerGap};

    ${h}
    color: ${({theme:e})=>e.mainText};

    &:hover,
    &:focus {
        color: ${({theme:e})=>e.radioButton.hover};
    }
`,Br=Gl(({label:e,id:o},r)=>ql(Fl,{ref:r,children:[Vt(Vl,{value:o,id:o,children:Vt(zl,{})}),Vt(Ll,{htmlFor:o,children:e})]}));Br.displayName="RadioItem";var ue={Root:me.Root,Item:Br};var Ul=Wl(ue.Root)`
    display: flex;
    flex-direction: row;

    gap: ${n[125]};

    @media (max-width: ${m.small}) {
        gap: ${n[100]};
    }
`,Ol={Root:Ul,Item:ue.Item};import Yl from"styled-components";import{forwardRef as Nl}from"react";import zt from"styled-components";import{jsx as Q,jsxs as Cr}from"react/jsx-runtime";var _l=zt.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`,Zl=zt(c.Paragraph)`
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: ${s.horizontalComponentGap};
    align-items: center;
`;function Ql({cardBrand:e}){switch(e){case"visa":return Q(or,{});case"mastercard":return Q(Jo,{});default:return Q(Bt,{})}}function Xl({cardBrand:e,cardLast4:o,expMonth:r,expYear:a,editButton:i}){let l=`0${r}`.slice(-2),g=a.toString().slice(-2),u=`${l}/${g}`;return Cr(_l,{children:[Cr(Zl,{children:[Q(Ql,{cardBrand:e}),Q("span",{"aria-label":`Credit card ending in ${o}`,children:`XXXX-XXXX-XXXX-${o}`}),Q("span",{"aria-label":"Expiration date",children:u})]}),i]})}var Kl=zt(M).attrs({$variant:"small"})`
    @media (max-width: ${m.small}) {
        ${U}

        .button-text {
            display: none;
        }
    }
`,tt=Nl(({text:e,...o},r)=>Q(Kl,{icon:jo,...o,ref:r,children:Q("span",{className:"button-text",children:e})}));tt.displayName="EditablePaymentMethod.EditButton";var Jl={Info:Xl,EditButton:tt};var jl=Yl(ue.Root)`
    display: flex;
    flex-direction: column;

    gap: ${n[150]};
`,es={Root:jl,Item:ue.Item,EditButton:tt};import{Elements as ts,PaymentElement as os,useElements as rs,useStripe as ns}from"@stripe/react-stripe-js";import{useState as as}from"react";import{useTheme as is}from"styled-components";import{jsx as kr}from"react/jsx-runtime";function ls({children:e,stripe:o,clientSecret:r}){let a=is();return kr(ts,{options:{clientSecret:r,appearance:{theme:"stripe",variables:{fontFamily:"Lato, sans-serif",fontSizeBase:"1rem",fontWeightNormal:"400",colorText:a.mainText,borderRadius:d.small,gridRowSpacing:n[50]},rules:{".Label":{textTransform:"uppercase",fontSize:"0.75rem",fontWeight:"700",color:a.notes,margin:`0 0 0 ${n[50]}`},".Label--invalid":{color:a.alert},".Input":{borderColor:a.stroke.light,borderWidth:"1px",padding:`${n[75]} ${n[50]}`},".Input:focus":{borderColor:a.focus,boxShadow:"none"},".Input--invalid:focus":{borderColor:a.alert,boxShadow:"none"},".Input::placeholder":{color:a.notes},".Error":{fontSize:"0.75rem",lineHeight:"normal",color:a.alert,margin:`0 0 0 ${n[50]}`},".TermsText":{fontSize:"0.75rem",color:a.notes}}}},stripe:o,children:e})}function ss(e){return kr(os,{...e,options:{fields:{billingDetails:"never"},wallets:{applePay:"never",googlePay:"never"}}})}var ds=()=>{let e=ns(),o=rs(),[r,a]=as(!1);return{isLoading:r,handleSubmitPaymentMethod:async l=>{if(l.preventDefault(),!e||!o)return{error:"Stripe.js has not yet loaded"};a(!0);let g=await e.confirmSetup({elements:o,confirmParams:{payment_method_data:{billing_details:{name:null,email:null,phone:null,address:{city:null,country:null,line1:null,line2:null,postal_code:null,state:null}}}},redirect:"if_required"});return a(!1),g.error?{error:`Confirm setup intent failed: ${g.error.message}`}:{data:g.setupIntent}}}};import L from"styled-components";import{jsx as k,jsxs as A}from"react/jsx-runtime";var ot=L.section`
    height: 64px;
    max-width: 640px;

    padding: ${s.horizontalComponentGap};
    border-radius: ${d.small};
    border: 1px solid ${({theme:e})=>e.stroke.light};

    display: grid;
    align-items: center;
    row-gap: 0.5rem;
    column-gap: 0.5rem;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'size action' 'price_and_source billing';

    @media (max-width: ${m.small}) {
        height: fit-content;
        max-width: 100%;

        grid-template-areas: 'size action' 'price_and_source billing';
    }
`,rt=L(c.SectionHeader)`
    ${to}
    grid-area: size;
    width: fit-content;
`,nt=L.div.attrs({role:"none"})`
    grid-area: price_and_source;
    display: flex;
    flex-direction: row;
    column-gap: 0.5rem;

    @media (max-width: ${m.small}) {
        flex-direction: column;
        row-gap: 0.5rem;
    }
`,Lt=L(c.Paragraph)`
    grid-area: price;
    align-self: center;

    @media (max-width: ${m.small}) {
        align-self: start;
    }
`,at=L(c.Secondary)`
    grid-area: source;
    ${W}

    align-self: center;

    @media (max-width: ${m.small}) {
        align-self: start;
    }
`,qt=L(c.Paragraph)`
    grid-area: billing;

    color: ${({theme:e,alert:o})=>o?e.alert:e.mainText};

    justify-self: end;
`,ps=L(M).attrs({$variant:"small"})`
    grid-area: action;
    justify-self: end;
`,cs=L(Z).attrs({$variant:"small"})`
    grid-area: action;
    justify-self: end;
`,ms=L.div.attrs({role:"none"})`
    grid-area: action;
    justify-self: end;
    width: 104px;
`,us=({sizeText:e,sourceText:o})=>A(ot,{children:[k(rt,{children:e}),k(nt,{children:A(at,{children:["(",o,")"]})})]}),gs=({sizeText:e,sourceText:o,priceText:r,billingInfoText:a,children:i})=>A(ot,{children:[k(rt,{children:e}),A(nt,{children:[r&&k(Lt,{children:r}),A(at,{children:["(",o,")"]})]}),k(qt,{children:a}),i]}),fs=({sizeText:e,sourceText:o,priceText:r,billingInfoText:a,children:i})=>A(ot,{children:[k(rt,{children:e}),A(nt,{children:[k(Lt,{children:r}),A(at,{children:["(",o,")"]})]}),k(qt,{alert:!0,children:a}),i]}),hs=({sizeText:e,sourceText:o,priceText:r,billingInfoText:a})=>A(ot,{children:[k(rt,{children:e}),A(nt,{children:[r&&k(Lt,{children:r}),A(at,{children:["(",o,")"]})]}),k(qt,{alert:!0,children:a}),k(ms,{})]});import Wt from"styled-components";import{jsx as Rr,jsxs as Ss}from"react/jsx-runtime";var bs=Wt(c.Subheader)`
    color: ${({theme:e})=>e.mainText};
    font-size: 2rem;
`,xs=Wt(c.Paragraph)`
    color: ${({theme:e})=>e.secondaryText};
    font-size: 1.5rem;
`,ys=Wt.section`
    display: grid;
    grid-row-gap: ${s.innerGap};
`,vs=({sizeText:e,priceText:o})=>Ss(ys,{children:[Rr(bs,{children:e}),Rr(xs,{children:o})]});import{forwardRef as Ps}from"react";import b from"styled-components";import{jsx as f,jsxs as Ce}from"react/jsx-runtime";var Mr=(l=>(l.Available="available",l.Unavailable="unavailable",l.Selected="selected",l.Active="active",l.Upcoming="upcoming",l))(Mr||{}),$s=b.table`
    width: 100%;
    max-width: 640px;
    display: grid;
    row-gap: ${s.horizontalComponentGap};
`,ws=b.tbody`
    display: grid;
    row-gap: ${s.horizontalComponentGap};
`,Ut=b.th.attrs({scope:"col"})`
    text-align: center;
    height: fit-content;
`,Er=b.tr`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr minmax(auto, 200px) minmax(auto, 200px);
    column-gap: ${s.horizontalComponentGap};
`,Ts=b(Er)`
    font-weight: 700;
`,Bs=b.th.attrs({scope:"row"})`
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    min-width: 65px;
`,Ir=b.td`
    text-align: center;
`,Cs=b(M).attrs({$variant:"large",$fluid:!0})`
    background-color: ${({theme:e})=>e.bluePress};
    &[data-hovered] {
        background-color: ${({theme:e})=>e.bluePress};
    }
`,ks=b(ee).attrs({$variant:"large",$fluid:!0,isDisabled:!0})``,Rs=b(ee).attrs({$variant:"large",$fluid:!0})``,Is=b(ee).attrs({$variant:"large",$fluid:!0,isDisabled:!0})`
    &[data-disabled] {
        background-color: ${({theme:e})=>e.buttons.teritary.default};
        color: ${({theme:e})=>e.buttons.teritary.content};
        border-color: ${({theme:e})=>e.stroke.dark2};
    }
`,As=b(ee).attrs({$variant:"large",$fluid:!0,isDisabled:!0})`
    &[data-disabled] {
        color: ${({theme:e})=>e.buttons.teritary.content};
        background-color: ${({theme:e})=>e.buttons.teritary.pressed};
    }
`,Be=b.span`
    white-space: initial;
`,Ar=b.span`
    white-space: nowrap;
`;function Dr({onPress:e,type:o,label:r,tag:a}){switch(o){case"selected":return f(Cs,{children:f(Be,{children:r})});case"unavailable":return f(ks,{children:f(Be,{children:r})});case"active":return f(Is,{children:Ce(Be,{children:[f(Ar,{children:r}),` (${a})`]})});case"upcoming":return f(As,{children:Ce(Be,{children:[f(Ar,{children:r}),` (${a})`]})});case"available":return f(Rs,{onPress:e,children:f(Be,{children:r})})}}function Ds({headers:[e,o,r],plans:a,onChoosePlan:i}){return Ce($s,{children:[f("thead",{children:Ce(Ts,{children:[f(Ut,{children:e}),f(Ut,{children:o}),f(Ut,{children:r})]})}),f(ws,{children:a.map(({storage:l,monthlyPlan:g,yearlyPlan:u},x)=>Ce(Er,{children:[f(Bs,{children:l}),f(Ir,{children:f(Dr,{type:g.type,onPress:()=>{i(g.id)},label:g.label,tag:g.tag})}),f(Ir,{children:f(Dr,{type:u.type,onPress:()=>{i(u.id)},label:u.label,tag:u.tag})})]},x))})]})}var Hr=Ps(({label:e,...o},r)=>f(Z,{$variant:"large",$fluid:!0,...o,ref:r,children:e}));Hr.displayName="SubscriptionsGrid.SubmitButton";var Ms=b.p`
    ${W}
    color: ${({theme:e})=>e.secondaryText};
    margin: 0;
`,Es={PlansTable:Ds,SubmitButton:Hr,ChangePlanPeriodNote:Ms};import X from"styled-components";import{jsx as G,jsxs as Ot}from"react/jsx-runtime";var Hs=X.table`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    width: 100%;
    display: grid;

    color: ${({theme:e})=>e.secondaryText};
`,Nt=X.th`
    display: flex;
    height: 100%;

    align-items: center;
    justify-content: center;

    font-weight: 400;
`,Gs=X(Nt)`
    background-color: ${({theme:e})=>e.emptyStateCard};
    border-radius: '4px 4px 0 0';
    border-bottom: 2px solid ${({theme:e})=>e.stroke.dark};
`,Gr=X.tr`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 96px 96px;
    grid-auto-rows: minmax(40px, auto);

    border-bottom: 1px solid ${({theme:e})=>e.stroke.dark};
`,Fs=X(Gr)`
    align-items: center;
`,Vs=X.th`
    display: flex;
    justify-content: left;
    align-items: center;

    min-width: 96px;

    font-weight: 400;
`,Fr=X.td`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: ${({theme:e})=>e.accent};
`,zs=X(Fr)`
    background-color: ${({theme:e})=>e.emptyStateCard};
`,Ls=({perkTitle:e,perkDetails:o})=>Ot(Hs,{children:[G("thead",{children:Ot(Fs,{children:[G(Nt,{}),G(Nt,{children:e.free}),G(Gs,{children:e.sub})]})}),G("tbody",{children:o.map(r=>Ot(Gr,{children:[G(Vs,{children:r.text}),G(Fr,{children:r.free&&G(Ue,{color:"currentcolor"})}),G(zs,{children:r.sub&&G(Ue,{color:"currentcolor"})})]},r.text))})]});export{gn as Accordion,bn as AccordionItem,Pl as ActionableTooltip,gs as ActiveSubscriptionInfo,ve as AlbumThumbnail,jn as Badge,Jn as BadgeGroup,aa as BadgeSelect,ie as BadgeText,Ta as BottomSheet,Ba as BottomSheetTrigger,ps as CancelSubscriptionButton,fs as CanceledSubscriptionInfo,Aa as Checkbox,Ha as ChoiceDrawer,Ga as ChoiceDrawerItem,Qn as CollectionsThumbnail,Ui as ContentLoader,za as ContextMenu,si as DataUsageBar,es as DigitalLegacyRadioGroup,I as DropdownMenu,Jl as EditablePaymentMethod,Hl as EmbeddedAreaIconOnDarkSurfaceButton,P as EmbeddedIconButton,ci as ErrorMessage,bi as FileInfoEntry,pl as FlowPrompt,Gi as Form,us as GrantedSubscriptionInfo,Dl as Hint,Al as HintProvider,Ol as HorizontalRadioGroup,sa as LinkButton,gr as Loader,ai as MePageUsageDescription,Ho as NavBarButton,hs as OverridedSubscriptionInfo,_i as PageCard,ba as PageNeutralButton,ga as PagePrimaryButton,ha as PagePrimaryDestructiveButton,fa as PageSecondaryButton,ja as ProgressBar,il as Prompt,vs as PurchaseProductInfo,cs as ResubscribeSubscriptionButton,Qi as ShortcutPageCard,wi as SideDrawer,Mr as StoragePlanType,ls as StripeElements,ss as StripePaymentElement,Ls as SubscriptionPerkTable,Es as SubscriptionsGrid,$o as ThumbnailExpandPreviewButton,fl as Toggle,Pa as ToolBarIconButton,xl as TooltipProvider,c as Typography,Zr as lightTheme,ds as useStripeSetupIntent};
//# sourceMappingURL=index.mjs.map